import React, {useState} from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from "react-bootstrap/Button";
import DatePicker from "react-date-picker";
import { ClientStyles } from "../../Styles/ClientStyles";
import TimePicker from "react-time-picker";
import Dropdown from "react-bootstrap/Dropdown";
import Image from "react-bootstrap/Image";
import { PaigesVinesComponentMessages } from "./PaigesVinesComponentMessages";
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import paigesVinesLogo from './../../Styles/Logos/paigesVineyardLogoTransparent.png';
import book from './../../Styles/Logos/PVBook.png'
import vineyard from './../../Home/assets/images/slide_02.jpg'
import barrels from './../../Styles/images/barrelRoom.JPG'
import lookingRight from './../../Styles/images/lisaLookingRight.jpg'
import './../../Styles/TimePicker.css';
import './../../Styles/DatePicker.css';
import './../PaigesVines.css';
import BookingContainer from "../../Booking/BookingContaner";


{/** start inclusion in SchedulerComponent.js */}
const PVDescriptionComponent = props => {
    switch(props.type){
        case 'Tasting Type':
            return(
              <div/>
            )
        case 'The Barrel Room':
            return(
                <> 

                <Col >
                    <Row>
                        <div style={ClientStyles.demo.centeredTitleBox}>The Barrel Room</div>
                    </Row>
                    <Row>
                        <Image src={barrels}  style={{paddingLeft:'40px', paddingRight:'40px'}}/>
                    </Row>
                    <Row>
                        <div style={ClientStyles.demo.centeredBodyBox}>Enjoy the beautiful environs of our Barrel Room while you sip our Willamette Valley Wines. This is an indoor tasting option allowing you to stay out of the weather.</div>
                    </Row>
                    
                </Col>
                </>
               
            )
        case 'Vineyard Overlook':
            return(
                <> 
                <Col>
                    <Row>
                        <div style={ClientStyles.demo.centeredTitleBox}>The Vinyard Overlook</div>
                    </Row>
                    <Row>
                        <Image src={lookingRight}  style={{paddingLeft:'40px', paddingRight:'40px'}}/>
                    </Row>
                    <Row>
                        <div style={ClientStyles.demo.centeredBodyBox}>Enjoy sweeping views of the vineyard while you sip our Willamette Valley Wines. This is an outdoor tasting option and will be open as weather permits.</div>
                    </Row>
                </Col>
                </>
                
            )
        default:
            return(
                <></>
            );
     }
}

PVDescriptionComponent.defaultProps = {

}
PVDescriptionComponent.propTypes = {
    type: PropTypes.string,
    updateType:PropTypes.func,
}


const PVPopupComponent = props => {
    const [dateValue, onChangeDate]= useState(new Date());
    const [timeValue, onChangeTime]= useState('10:00');
    function handleClick(selection){
        props.updateType(selection)
    }
    function handleSubmit(event) {
        props.updateSubmit('submit')
        event.preventDefault();

    }
    

    switch(props.submit){
        case 'submit':
            return(
            <>
            <div style={{backgoundColor:'#E0E0E0'}}>
              <Row >
                <Col style={{display:'flex', alignItems:'centered', justifyContent:'center'}}>
                    <div style={{fontSize:'5vh', color:'#506638',  fontWeight:'bold'}}>Thank you!</div>
                </Col>
              </Row>
              <Row >
                <Col style={{display:'flex', alignItems:'centered', justifyContent:'center'}}>
                    <div style={{fontSize:'3vh', color:'#a4c639', fontWeight:'bold'}}>{`Your tasting has been reserved on: ${'\n'} ${dateValue.toDateString()} in the ${props.type}` }</div>
                </Col>
              </Row>
              </div>
            </>
            )
        default:
            return(
                <Row style={{backgoundColor:'#E0E0E0'}}>
                <Col style={{display:'flex', alignItems:'centered', justifyContent:'center',borderRadius:'10px', padding:'40px', opacity:'100%', font:ClientStyles.demo.defaultFont}}>
                    <Row>
                        <div style={ClientStyles.demo.defaultFont}>
                        <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>{PaigesVinesComponentMessages.emailAddress}</Form.Label>
                            <Form.Control type="email" placeholder={PaigesVinesComponentMessages.enterEmail} style={ClientStyles.demo.formFields}/>
                            <Form.Text className="text-muted" style={{fontSize:'10pt'}}>
                            {PaigesVinesComponentMessages.neverShare}
                            </Form.Text>
                        </Form.Group>
                        <InputGroup style={{display:'flexbox', flexDirection:'reverse'}}>
                            <Form.Control
                            placeholder={PaigesVinesComponentMessages.party}
                            aria-label="Party Size"
                            style={ClientStyles.demo.formFields}
                            />
                            <Button variant="outline-secondary" style={ClientStyles.demo.formFields}>-</Button>
                            <Button variant="outline-secondary" style={ClientStyles.demo.formFields}>+</Button>
                        </InputGroup>
                        <br></br>
                        <Dropdown>
                            <Dropdown.Toggle
                            variant="sucess"
                            id="dropdown-basic"
                            style={ClientStyles.demo.dropdown}>
                                {props.type}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item href="#/Barrel-Room" onClick={()=>handleClick('The Barrel Room')}>Barrel Room - Indoor</Dropdown.Item>
                                <Dropdown.Item href="#/Overlook" onClick={()=>handleClick('Vineyard Overlook')}>Vinyard Overlook - Outdoor</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <br></br>
                        <div>
                            <DatePicker onChange={onChangeDate} value={dateValue} />
                        </div>
                        <br></br>
                        <div style={ClientStyles.demo.formFields}>
                            <TimePicker onChange={onChangeTime} value={timeValue} disableClock={true}/>
                        </div>
                        <br></br>
                        <Button variant="primary" type="submit" style={ClientStyles.demo.button}>
                            Submit
                        </Button>
                        
                        </Form>
                        </div>
                    </Row>
                </Col>
                <PVDescriptionComponent type={props.type}/>
                </Row>  
        );
     }
    

        

}

PVPopupComponent.defaultProps = {

}
PVPopupComponent.propTypes = {
    type: PropTypes.string,
    updateType:PropTypes.func,

    submit:PropTypes.string,
    updateSubmit:PropTypes.func,
}

{/**end inclusion in Scheduler component */}

const PaigesVinesComponent = props => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const navigate = useNavigate();
    function handleExit() {
        props.updateTab('/Services');
        navigate('/Services');
        
    }

    return(
        <>
        <div style={{height:'20vh', width:'100vw', boxShadow:'0px 5px 20px #4b1c37'}}>
            <Row >
                <Col lg='2'>
                    <Image src={paigesVinesLogo}  style={{height:'18vh'}}/>
                </Col>
                <Col style={{padding:'10vh'}} lg='1'>
                    <Dropdown>
                        <Dropdown.Toggle
                        variant="sucess"
                        id="dropdown-basic"
                        style={ClientStyles.demo.dropdownHeader}>
                            Our Wines
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item>White</Dropdown.Item>
                            <Dropdown.Item>Rose</Dropdown.Item>
                            <Dropdown.Item>Red</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col style={{padding:'10vh'}} lg='1'>
                <Dropdown>
                        <Dropdown.Toggle
                        variant="sucess"
                        id="dropdown-basic"
                        style={ClientStyles.demo.dropdownHeader}>
                            About Us
                        </Dropdown.Toggle>
                    </Dropdown>
                </Col>
                <Col style={{padding:'10vh'}} lg='2'>
                    <Button variant="light" style={ClientStyles.demo.buttonHeader} >
                        Visit Us
                    </Button>
                </Col>
                <Col style={{display:'inline-flex', alignContent:'Right', justifyContent:'Right', padding:'10vh'}}>
                    <Row style={{display:'inline-flex'}}>
                        <Col>
                            <Button variant="light" style={ClientStyles.demo.buttonHeader} >
                                Log In
                            </Button>
                        </Col>
                        <Col>
                        
                        <Button variant="light" type="submit" style={ClientStyles.demo.buttonHeader}  onClick={()=>handleExit()}>
                            Exit Demo
                        </Button>
                        </Col>
                    </Row>
                </Col>  
            </Row>
        </div>
        <div style={{ height:'80vh', width:'100vw'}}>

            <br></br>
            <div style={{ backgroundImage: `url(${vineyard})`,backgroundPosition:'center', height:'70vh'}}>
                <Row style={{fontSize:'4vh', color:'#a4c639', paddingTop:'10vh', paddingLeft:'10vh', fontWeight:'lighter'}}>
                    Experience wines from the
                    
                </Row>
                <Row style={{fontSize:'8vh', color:'#a4c639', paddingLeft:'10vh', fontWeight:'bold'}}>
                    Willamette Valley
                </Row>
                <Row>
                    <Col style={{fontSize:'2vh', color:'#f7f7f7', padding:'10vh', fontWeight:'lighter'}}>
                        <div>Join us for a unique tasting experience! Try our White, Red, and Rose wines all from grapes grown right here in the Willamette Valley.</div>
                        <div>We are open Friday through Sunday from 11am - 4pm</div>
                        <div>Looking forward to seeing you soon!</div>
                    </Col>
                </Row>
                <Row style={{width:'20vw',paddingLeft:'10vh'}}>
                    <Button variant="primary" style={ClientStyles.demo.button} onClick={handleShow}>
                        Book Now
                    </Button>
                </Row>
            </div>
            {/** Start of code for new component
             * It will need scheduler Container
             * 
             * (code below will be called in render of SchedulerComponent.js)
             * 
             */}
            <Modal 
                size="lg" 
                show={show} 
                backdrop="static"
                onHide={handleClose} 
                style={{height:'100vh', width:'100vw'}}
            >
                <Modal.Header closeButton>
                <Modal.Title><Image src={book}  style={{height:'10vh'}}/></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/** 
                    <PVPopupComponent 
                        type={props.type} updateType={props.updateType}
                        submit={props.submit} updateSubmit={props.updateSubmit}
                    />
                    */}    
                    <BookingContainer></BookingContainer>
                </Modal.Body>

               
            </Modal>
          {/** End */}
            {/*<PVPopupComponent type={props.type} updateType={props.updateType}/>*/}
            <br></br>
        </div>
        <footer>
            <div class="container">
                <div>
                    <h4>Paige's Vineyard</h4>
                    <p>We are on a mission to bring you the best wines from our Willamette Valley winery.</p>
                    <ul class="social-icons">
                    <li><a rel="nofollow" href="https://fb.com/templatemo" target="_blank"><i class="fa fa-facebook"></i></a></li>
                    <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                    <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
                    <li><a href="#"><i class="fa fa-behance"></i></a></li>
                    </ul>
                </div>

            </div>
        </footer></>
    );
}

PaigesVinesComponent.defaultProps = {

}
PaigesVinesComponent.propTypes = {
    type: PropTypes.string,
    updateType:PropTypes.func,

    submit:PropTypes.string,
    updateSubmit:PropTypes.func,

    tab: PropTypes.string,
    updateTab:PropTypes.func,
}

export default (PaigesVinesComponent);